var map = {
	"./adn.webp": "c0de",
	"./licenciatura.svg": "23bd",
	"./logoNG.webp": "a9d8",
	"./portada.webp": "a1b8",
	"./preparatoria.svg": "7187",
	"./primaria.svg": "dc3f",
	"./secundaria.svg": "495d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "82b5";